'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  color: ', ';\n  background: ', ';\n  box-shadow: ', ';\n  border-radius: ', ';\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  user-select: none;\n  justify-content: space-between;\n'], ['\n  width: 100%;\n  color: ', ';\n  background: ', ';\n  box-shadow: ', ';\n  border-radius: ', ';\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  user-select: none;\n  justify-content: space-between;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Stlyes


var types = {
  error: _colors.red,
  warning: _colors.orange,
  info: _colors.blue,
  success: _colors.green,
  plain: _colors.grey
};

var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var type = _ref.type;
  return type === 'plain' ? _colors.darkGrey : _colors.white;
}, function (_ref2) {
  var type = _ref2.type;
  return types[type];
}, function (_ref3) {
  var flat = _ref3.flat;
  return flat ? 'none' : '0 2px 20px 0 rgba(0, 0, 0, 0.1)';
}, function (_ref4) {
  var flat = _ref4.flat;
  return flat ? '0px' : '10px';
});

Container.propTypes = {
  type: _propTypes2.default.string
};
exports.default = Container;